module.exports = __webpack_public_path__ + "img/13a.d809e1de.jpg";